module.exports = __webpack_public_path__ + "static/media/bg black.e678c36d.svg";